import { render, staticRenderFns } from "./NotificationAlerts.vue?vue&type=template&id=5d4d3bfe"
import script from "./NotificationAlerts.vue?vue&type=script&lang=js"
export * from "./NotificationAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports